module.exports = __webpack_public_path__ + "static/media/envpol.adcfa78a.jpg";